import { RouteProps } from "react-router-dom";

import {
  AccountInfo,
  AuthSettings,
  Dashboard,
  PageSelection,
  PayoutSettings,
  ScheduledDeletion,
  Team,
} from "components/account/pages";
import { NameSpace } from "translations/shared";
import { getRoutePath } from "utils";

export default (): {
  ns: NameSpace;
  routes: RouteProps[];
  loggedInRoutes: RouteProps[];
  loggedOutRoutes: RouteProps[];
} => {
  // prettier-ignore
  const routes: RouteProps[] = [];

  // prettier-ignore
  const loggedInRoutes: RouteProps[] = [
    { path: getRoutePath("account","DASHBOARD"), element: <Dashboard /> },
    
    { path: getRoutePath("account","SCHEDULED_DELETION"), element: <ScheduledDeletion /> },

    { path: getRoutePath("account","SETTINGS"), element: <PageSelection /> },
    { path: getRoutePath("account","SETTINGS_INFO"), element: <AccountInfo /> },
    { path: getRoutePath("account","SETTINGS_AUTH"), element: <AuthSettings /> },
    { path: getRoutePath("account","SETTINGS_TEAM"), element: <Team /> },
    { path: getRoutePath("account","SETTINGS_TEAM_MEMBERS"), element: <Team /> },
    { path: getRoutePath("account","SETTINGS_PAYOUT"), element: <PayoutSettings /> },
  ];

  // prettier-ignore
  const loggedOutRoutes: RouteProps[] = [];

  return { ns: "account", routes, loggedInRoutes, loggedOutRoutes };
};
